var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHomeNotActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 19V10C4.25 9.68333 4.321 9.38333 4.463 9.1C4.605 8.81667 4.80067 8.58333 5.05 8.4L11.05 3.9C11.4 3.63333 11.8 3.5 12.25 3.5C12.7 3.5 13.1 3.63333 13.45 3.9L19.45 8.4C19.7 8.58333 19.896 8.81667 20.038 9.1C20.18 9.38333 20.2507 9.68333 20.25 10V19C20.25 19.55 20.054 20.021 19.662 20.413C19.27 20.805 18.7993 21.0007 18.25 21H15.25C14.9667 21 14.7293 20.904 14.538 20.712C14.3467 20.52 14.2507 20.2827 14.25 20V15C14.25 14.7167 14.154 14.4793 13.962 14.288C13.77 14.0967 13.5327 14.0007 13.25 14H11.25C10.9667 14 10.7293 14.096 10.538 14.288C10.3467 14.48 10.2507 14.7173 10.25 15V20C10.25 20.2833 10.154 20.521 9.962 20.713C9.77 20.905 9.53267 21.0007 9.25 21H6.25C5.7 21 5.22933 20.8043 4.838 20.413C4.44667 20.0217 4.25067 19.5507 4.25 19Z",
    fill: "white",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeNotActive);
export default __webpack_public_path__ + "static/media/icon_home_notActive.3123cf575314e0480ba4b724712ff82b.svg";
export { ForwardRef as ReactComponent };